"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var asset_accessor_1 = require("../asset-accessor");

var graphql_asset_accessor_1 = require("./graphql-asset-accessor");

var GraphQLImageAccessor =
/** @class */
function () {
  function GraphQLImageAccessor(base) {
    this.base = base;
  }

  GraphQLImageAccessor.prototype.asset = function () {
    if (this.base) {
      var value = this.base['image'];
      return new graphql_asset_accessor_1.GraphQLAssetAccessor(value);
    }

    return new asset_accessor_1.NullAssetAccessor();
  };

  GraphQLImageAccessor.prototype.metadata = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

    var original = (_e = (_d = (_c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.localFile) === null || _c === void 0 ? void 0 : _c.childImageSharp) === null || _d === void 0 ? void 0 : _d.original, _e !== null && _e !== void 0 ? _e : undefined);
    var focalPoint = (_h = (_g = (_f = this.base) === null || _f === void 0 ? void 0 : _f.focalPoint) === null || _g === void 0 ? void 0 : _g.focalPoint, _h !== null && _h !== void 0 ? _h : undefined);
    return {
      original: original,
      focalPoint: focalPoint,
      description: (_k = (_j = this.base) === null || _j === void 0 ? void 0 : _j.description, _k !== null && _k !== void 0 ? _k : undefined),
      caption: (_l = this.base) === null || _l === void 0 ? void 0 : _l.caption
    };
  };

  GraphQLImageAccessor.prototype.fluid = function (opts) {
    var _a, _b, _c, _d, _e, _f, _g;

    var aspectRatio = (_b = util_1.createQueryableAspectRatioFromString((_a = opts) === null || _a === void 0 ? void 0 : _a.aspectRatio), _b !== null && _b !== void 0 ? _b : 'original');
    var localImageFile = (_d = (_c = this.base) === null || _c === void 0 ? void 0 : _c[aspectRatio], _d !== null && _d !== void 0 ? _d : undefined);

    if (!localImageFile) {
      console.error("Could not query an image with aspect ratio " + aspectRatio + ".");
    }

    return _g = (_f = (_e = localImageFile) === null || _e === void 0 ? void 0 : _e.childImageSharp) === null || _f === void 0 ? void 0 : _f.fluid, _g !== null && _g !== void 0 ? _g : util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  return GraphQLImageAccessor;
}();

exports.GraphQLImageAccessor = GraphQLImageAccessor;